import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import Text from '../../typography/Text';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Badge');
const fontBySize = {
  tiny: 'badges',
  small: 'badges',
  medium: 'caption'
};
function BadgeNotification(_ref) {
  let {
    classes: classesProp,
    children,
    overrides: overridesProp,
    className: classNameProp,
    size = 'medium',
    ...props
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  // Overrides
  const override = getOverrides(overridesProp, BadgeNotification.overrides);

  // Classes
  const rootClassName = classnames(classes.root, {
    [classes[size]]: size
  }, classNameProp);
  const rootProps = {
    ...props,
    className: rootClassName
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, rootProps, override.root), /*#__PURE__*/React.createElement(Text, _extends({
    type: fontBySize[size] || fontBySize.medium,
    className: classes.Text
  }, override.Text), children));
}
BadgeNotification.overrides = ['root', 'Text'];
process.env.NODE_ENV !== "production" ? BadgeNotification.propTypes = {
  /** Content to be displayed inside the notification badge, typically a number */
  children: PropTypes.node.isRequired,
  /** Custom CSS class for styling */
  className: PropTypes.string,
  /** Object with custom style overrides for inner elements */
  overrides: PropTypes.object,
  /** Size of the notification badge, affecting dimensions and font size */
  size: PropTypes.oneOf(['tiny', 'small', 'medium'])
} : void 0;
export default /*#__PURE__*/React.memo(BadgeNotification);